/**
 * Data block: reads isEnabled from a SceneObject.
 * Pure data node — no flow sockets. Output is pulled when a downstream
 * execution node needs the value.
 */

import { FlowGraphBlock } from "@babylonjs/core/FlowGraph/flowGraphBlock";
import type { FlowGraphContext } from "@babylonjs/core/FlowGraph/flowGraphContext";
import type { IFlowGraphBlockConfiguration } from "@babylonjs/core/FlowGraph/flowGraphBlock";
import { RichTypeBoolean } from "@babylonjs/core/FlowGraph/flowGraphRichTypes";
import { resolveTarget } from './traceContext';

export class TraceGetActiveBlock extends FlowGraphBlock {
    private _targetPath: string;

    constructor(config?: IFlowGraphBlockConfiguration & { target?: string }) {
        super(config);
        this._targetPath = config?.target ?? '';
        this.registerDataOutput("value", RichTypeBoolean);
    }

    public override _updateOutputs(context: FlowGraphContext): void {
        const target = resolveTarget(context, this._targetPath);
        this.getDataOutput("value")!.setValue(target?.active ?? false, context);
    }

    public override getClassName(): string {
        return "TraceGetActiveBlock";
    }
}
